(ns ui.view.transaction-process.modals.declaration.event
  (:require
   [frontend.actions.declaration :as declaration-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.utils :as fu]
   [re-frame.core :as rf]
   [ui.state.session.cofx :as session-cofx]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.modals.declaration.model :as model]
   [ui.view.transaction-process.model :as tp-model]
   [ui.view.transaction-process.util :as tp-util]))

(rf/reg-event-fx
 ::open
 [rf/trim-v (rf/inject-cofx ::session-cofx/session-context)]
 (fn [{:keys [db session-context]} [{:keys [state-path] :as _ctx}
                                    {:keys [slot-kw declaration-type-label existing-declaration]}]]
   (let [form (if existing-declaration
                (model/init-edit-state
                 {:declaration            (common/get-entity (:entities session-context)
                                                             (:db/id existing-declaration))
                  :slot-kw                slot-kw
                  :declaration-type-label declaration-type-label})
                (model/init-create-state
                 {:slot-kw                slot-kw
                  :declaration-type-label declaration-type-label}))]
     {:db (-> db
              (assoc-in (tp-model/modal-full-path state-path)
                        {:modal/modal-type (if existing-declaration :declaration-edit :declaration-create)})
              (assoc-in (common/form-full-path state-path) form))})))

(rf/reg-event-db
 ::set-field
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} field value]]
   (assoc-in db (common/form-key-full-path state-path field) value)))

(rf/reg-event-db
 ::set-status
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} status]]
   (let [{:keys [not-applicable? completed?]} (tp-util/declaration-status->flags status)]
     (update-in db (common/form-full-path state-path)
                merge {:declaration/not-applicable? not-applicable?
                       :declaration/completed?      completed?}))))

(rf/reg-event-fx
 ::save
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path process-id] :as ctx} draft?]]
   (let [form     (-> (get-in db (common/form-full-path state-path))
                      (assoc :draft? draft?))
         new-db   (assoc-in db (common/form-full-path state-path)
                            (assoc form :submitting? true :error nil))]
     (if (:edit-mode? form)
       {:db new-db
        ::common/run-action
        {:action     (fn [success! error!]
                       (entity-actions/*->entity-update!
                        (:entity-id form) (model/->update-attrs form) success! error!))
         :on-success [::save-success ctx]
         :on-error   [::save-error ctx]}}
       (let [declaration-id (fu/create-temp-id "temp-declaration-")
             entity         (model/->create-entity form declaration-id)]
         {:db new-db
          ::common/run-action
          {:action     (fn [success! error!]
                         (declaration-actions/*->create-with-response
                          {:declaration-id declaration-id
                           :process-id     process-id
                           :slot-attr      (:slot-kw form)
                           :entities       {declaration-id entity}}
                          success! error!))
           :on-success [::save-success ctx]
           :on-error   [::save-error ctx]}})))))

(rf/reg-event-fx
 ::save-success
 [rf/trim-v]
 (fn [_ [ctx _resp]]
   (common/save-success-effects ctx)))

(rf/reg-event-db
 ::save-error
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} err]]
   (common/save-error-db db
                         {:state-path state-path}
                         err
                         {:log-message     "Failed to save declaration"
                          :fallback-tr-key :transaction-process/save-declaration-error})))
